export default __webpack_public_path__ + "static/media/shop8.dcf9ca91.jpg";